import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, User } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr, setToken } from "@/lib/api";
import Logo from "@/components/Logo";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { login, password });
      setToken(r.data.token);
      toast.success("Connecté");
      navigate("/admin");
    } catch (err) { toast.error(formatErr(err)); } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center px-4">
      <form onSubmit={submit} className="w-full max-w-md bg-slate-800 border border-slate-700 rounded-2xl p-8" data-testid="admin-login-form">
        <Logo tone="light" className="h-9" />
        <div className="text-slate-400 text-sm font-semibold mt-3">Espace Admin</div>
        <div className="grid gap-3 mt-6">
          <div className="relative">
            <User size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
            <input type="text" required autoComplete="username" className="w-full h-12 pl-10 pr-4 bg-slate-900 border border-slate-600 rounded-xl text-white text-sm outline-none focus:border-brand" placeholder="Identifiant ou email" value={login} onChange={(e) => setLogin(e.target.value)} data-testid="admin-email" />
          </div>
          <div className="relative">
            <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
            <input type="password" required autoComplete="current-password" className="w-full h-12 pl-10 pr-4 bg-slate-900 border border-slate-600 rounded-xl text-white text-sm outline-none focus:border-brand" placeholder="Mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" />
          </div>
        </div>
        <button disabled={loading} className="mt-5 w-full bg-brand hover:bg-brand-600 text-white font-bold rounded-xl py-3.5 disabled:opacity-50 transition-colors" data-testid="admin-login-submit">{loading ? "..." : "Se connecter"}</button>
        <p className="text-slate-500 text-xs text-center mt-4">Accès réservé. Toutes les actions sont tracées.</p>
      </form>
    </div>
  );
}
